<template>
  <div>
    <div class="wBh_hh_PhoneLayer">
      <div class="gs_GuaranteeLayer" style="margin-top: -325px;height: 657px;">
        <span class="wBh_Close">
          <img src="@/assets/bh_close.png" />
        </span>
        <h5 class="gs_GuaranteeLayer_Title">关于中国农业银行</h5>
        <div class="gs_Guarantee_Wrap clear">
          <!--第一页                 **************          开始-->
          <div class="gs_GuaranteeMain4 gs_GuaranteeMain_Active">
            <h3 class="gs_GuaranteeTitle"><i></i>关于中国农业银行</h3>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              中国农业银行成立于1951年，是新中国设立的第一家国有商业银行，经过70年的砥砺耕
              耘，已发展成为一家面向“三农”、城乡联动、融入国际、服务多元的综合性金融服务商业
              银行之一。嘉峪关农行作为全市优秀的商业银行之一，多年来紧紧围绕全省改革发展部署和
              小康建设大局，积极服务经济社会发展，已成为支持甘肃经济和社会发展不可或缺的重要金
              融力量。
            </h5>
             <h3 class="gs_GuaranteeTitle"><i></i>保函手续费：</h3>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
             按照开立保函金额的0.6%收取手续费，修改保函：100元/笔。
            </h5>
          </div>
          <!--第一页                 **************          结束-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

import "@/assets/css/about_danbao.css";

export default {
  name: "register",
  data() {
    return {};
  },
  mounted() {
    var that = this;
    var $li = $(".pageNumWrap4 li");
    var len = $li.length - 1;
    var _index = 0; //li的索引
    var $img = $(".gs_GuaranteeMain4");
    play();
    //点击事件
    $li.click(function() {
      _index = $(this).index();
      play();
    });

    function play() {
      //获取li的下标，改变样式
      $li
        .eq(_index)
        .addClass("active")
        .siblings()
        .removeClass("active");
      //获取图片的下标，实现淡入淡出
      $img
        .eq(_index)
        .slideDown()
        .siblings()
        .slideUp();
    }

    //两边耳朵的点击事件
    $(".gs_PageBtn").click(function() {
      var index = $(this).index();
      if (index) {
        _index++;
        if (_index > len) {
          _index = 0;
        }
        play();
      } else {
        _index--;
        if (_index < 0) {
          _index = len;
        }
        play();
      }
    });
    layui.use(
      ["jquery", "element", "step", "form", "laydate", "layer", "table"],
      function() {
        var $ = layui.jquery,
          form = layui.form,
          step = layui.step,
          element = layui.element,
          table = layui.table,
          layer = layui.layer,
          laydate = layui.laydate;
      }
    );
  },
  beforeCreate() {
    // console.group('beforeCreate 创建前状态===============》');
  },
  created() {
    // loadingInstance.close();
  }
};
</script>

<style></style>
